(function () {
    'use strict';
    var app = angular.module('inoApp');
    app.config(['$translateProvider', '$translatePartialLoaderProvider', 'commonConfigProvider', function ($translateProvider, $translatePartialLoaderProvider, commonConfigProvider) {
        $translateProvider.useSanitizeValueStrategy('escaped');

        $translatePartialLoaderProvider.addPart('InovestorFramework/Core/app/resources');
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: commonConfigProvider.config.clientAppSrcPath + '{part}/locale-{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
    }]);
})();